import { Fragment } from 'react';
import { Button } from '@landlord-tech/opp-ui-kit';

import { Hit, BaseHit } from 'instantsearch.js';
import { connectInfiniteHits } from 'react-instantsearch-dom';

import { THitsProps, TInfiniteHitsProvided } from 'components/Base/Algolia/types';
import { SLoadMoreWrapper } from './style';

function WrappedInfiniteHits<THit>({
  hits,
  hasMore,
  refineNext,
  hitComponent: HitComponent,
}: TInfiniteHitsProvided<THit>) {
  return (
    <>
      {hits.map((item, index) => (
        <Fragment key={`hit-${index}`}>{HitComponent(item as Hit<THit & BaseHit>)}</Fragment>
      ))}
      {hasMore && (
        <SLoadMoreWrapper>
          <Button text='Load More' onClick={refineNext} />
        </SLoadMoreWrapper>
      )}
    </>
  );
}

function InfiniteHits<Thit>(props: THitsProps<Thit>) {
  const Component = connectInfiniteHits((infiniteHitsProps) => WrappedInfiniteHits({ ...props, ...infiniteHitsProps }));
  return <Component />;
}

export default InfiniteHits;
